import { render, staticRenderFns } from "./VuesticIconCleanCode.vue?vue&type=template&id=973493f8"
import script from "./VuesticIconCleanCode.vue?vue&type=script&lang=js"
export * from "./VuesticIconCleanCode.vue?vue&type=script&lang=js"
import style0 from "./VuesticIconCleanCode.vue?vue&type=style&index=0&id=973493f8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('973493f8')) {
      api.createRecord('973493f8', component.options)
    } else {
      api.reload('973493f8', component.options)
    }
    module.hot.accept("./VuesticIconCleanCode.vue?vue&type=template&id=973493f8", function () {
      api.rerender('973493f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-icon/VuesticIconCleanCode.vue"
export default component.exports